angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/proposals/proposal.html',
    '<!-- proposal  -->\n' +
    '<section class="content dashboard" ng-init="initProposal()">\n' +
    '    <div class="container">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-sm-5 col-sm-push-7 project-messages">\n' +
    '                <!-- Breadcrumbs -->\n' +
    '                <div class="breadcrumbs">\n' +
    '                    <a href="" ui-sref="projects">Projects</a>\n' +
    '                    <i class="fa fa-chevron-right"></i>\n' +
    '                    <a href="" ui-sref="project({uid: project.UID})" style="word-wrap: break-word;">{{project.Title}}</a>\n' +
    '                    <i class="fa fa-chevron-right"></i>\n' +
    '                    Proposal\n' +
    '                </div>\n' +
    '                <messages></messages>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-sm-7 col-sm-pull-5">\n' +
    '                <h2>Engineer Proposal</h2>\n' +
    '                <div class="dashboard-box">\n' +
    '                    <!-- Estimate -->\n' +
    '                    <div class="project-estimate">\n' +
    '                        <div class="project-rate range">\n' +
    '                            <span id="proposalEstimate">Estimate:</span>\n' +
    '                            <span ng-if="proposal.Estimate"><font/>{{proposal.Estimate | currency:"":2}}\n' +
    '                                <span ng-if="proposal.Hourly==true">/hr</span>\n' +
    '                            </span>\n' +
    '                            <span ng-if="(!proposal.Estimate) && (!proposal.Hourly)"> <font/>{{proposal.LowestRange | currency:"":2}} -<font/>{{proposal.HighestRange | currency:"":2}}\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                        <a class="btn btn-primary btn-lg btn-four" ng-show="project.Status == \'open\'" href="" ng-click="hire()">Hire</a>\n' +
    '                    </div>\n' +
    '                    <!-- Profile -->\n' +
    '                    <ul class="list-inline user-profile">\n' +
    '                        <li class="user-profile-photo">\n' +
    '                            <!-- Keep second background-image avater.png as is! Replace first [avatar-01.jpg] with user\'s photo -->\n' +
    '                            <div class="user-photo" style="background-image:url({{profileData.user.Picture.Url}}),url(assets/img/avatar.png);"></div>\n' +
    '                            <!-- Rating -->\n' +
    '                            <div class="rating profile" ng-show="profileData.user.IsProfessional">\n' +
    '                                <span ng-repeat="i in [5, 4, 3, 2, 1]" ng-class="{\'on\': i <= profileData.user.AverageScore}"></span>\n' +
    '                            </div>\n' +
    '                        </li>\n' +
    '                        <li class="user-info">\n' +
    '                            <!-- Profile Info -->\n' +
    '                            <h5>{{::profileData.user.Company}}</h5>\n' +
    '                            <h4 style="cursor:pointer" ui-sref="profileProposal({proposalId: proposal.Id})">{{::profileData.user.FullName}}</h4>\n' +
    '                            <address ng-show="project.Status != status_to_hire_contact_info_to_client">\n' +
    '                                <i class="fa fa-envelope fa-fw" ng-show="::profileData.user.Email"></i>\n' +
    '                                {{::profileData.user.Email}}\n' +
    '                                <br>\n' +
    '                                <i class="fa fa-phone fa-fw" ng-show="::profileData.user.Phone"></i>\n' +
    '                                {{::profileData.user.Phone}}\n' +
    '                            </address>\n' +
    '                            <span ng-if="profileData.user.IsProfessional" ng-repeat="license in groupedLicenses">\n' +
    '                                <i class="fa fa-wrench fa-fw"></i>\n' +
    '                                {{license.label}}:\n' +
    '                                <strong style="color: #1c75bc;" ng-repeat="state in license.states">\n' +
    '                                    <span ng-if="$index>0" style="color:black; font-weight: lighter;">, </span>{{state}}</strong>\n' +
    '                                <br>\n' +
    '                            </span>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '                <!-- Text -->\n' +
    '                <div class="dashboard-box">\n' +
    '                    <h4>Proposal</h4>\n' +
    '                    <div class="row">\n' +
    '                        <div class="col-sm-12 col-md-11 project-descr">\n' +
    '                            <div style="word-wrap: break-word; white-space: pre-wrap;">{{proposal.Description}}</div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <!-- Attachment -->\n' +
    '                <div class="dashboard-box" ng-show="proposal.Attachment">\n' +
    '                    <h4>Attachment</h4>\n' +
    '                    <div class="project-docs">\n' +
    '                        <ul class="list-group no-shadow bullets-a-style alt">\n' +
    '                            <li class="list-group-item">\n' +
    '                                <a ng-href="{{proposal.Attachment.Url}}" target="_blank" download>{{proposal.Attachment.Name}}</a>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '</section>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-hire.html">\n' +
    '<div class="modal-header">\n' +
    '<a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '    <i class="fa fa-times"></i>\n' +
    '</a>\n' +
    '<h4 class="modal-title">Hire Now</h4>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '<p>\n' +
    '    Please confirm, that you \'Agree\' to hire\n' +
    '    {{name}}\n' +
    '    for your project.\n' +
    '    <br>\n' +
    '    <br>\n' +
    '    We will sent a notification about your decision immediately.\n' +
    '</p>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '<button type="button" ng-click="$close()" class="btn btn-default">No</button>\n' +
    '<button ng-click="agreed()" class="btn btn-primary">Agree</button>\n' +
    '</div>\n' +
    '</script>');
}]);
